'use client'

import { usePageData } from '@/contexts/PageDataContext'
import type { TransformBreadcrumbsOptions } from '@/helpers/transforms'
import { transformBreadcrumbs } from '@/helpers/transforms'
import Link from 'next/link'
import type { FC } from 'react'
import BreadcrumbLink from '../atoms/BreadcrumbLink'
import { FontAwesomeIcon } from '../atoms/FontAwesomeIcon'

export type BreadcrumbProps = TransformBreadcrumbsOptions

const Breadcrumb: FC<BreadcrumbProps> = (props) => {
	const data = usePageData()
	const links = transformBreadcrumbs(data, props)
	if (data.isFrontPage) return null

	return (
		<div className="flex gap-x-xs">
			<Link href="/" className="text-blue" aria-label="GIICA Homepage">
				<FontAwesomeIcon icon={['fal', 'home']} size="md" />
			</Link>
			{links.map((link, index) => (
				<div key={link.href || index} className="flex items-center gap-x-xs">
					<span className="text-body-xs text-blue">/</span>
					<BreadcrumbLink {...link} />
				</div>
			))}
		</div>
	)
}

export default Breadcrumb
